import React from "react";
import { AlertTriangle } from "lucide-react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center text-center px-6 bg-[#FFF7E6]" data-testid="error-boundary">
          <AlertTriangle className="w-14 h-14 text-[#DC2626] mb-4" />
          <h1 className="text-2xl font-bold text-[#111827]">Something went wrong</h1>
          <p className="text-[#111827]/60 mt-2 mb-6">An unexpected error occurred. Let's get you back to safety.</p>
          <a href="/home" data-testid="error-return-home" className="bg-[#F97316] text-white rounded-2xl py-3 px-6 font-bold">Return Home</a>
        </div>
      );
    }
    return this.props.children;
  }
}
